module.exports = __webpack_public_path__ + "static/media/user_account_selected.6b197da1.svg";